import React, {useEffect} from 'react'
import Select from 'react-select'
import { Button, Row, Col, Input } from 'reactstrap'
//import getRoleList from '../../../../service/getRoles';
//import { labelizeNamedData } from '@/shared/helpers'

const FilterForm = ({onClickFilterCallback, filter, organization}) => {
    const [keyword, setKeyword] = React.useState('');
    const [role, setUserRole]   = React.useState('');
    const [selectedRole, setSelectedRoleName]   = React.useState('');
    const [roleOptions, setRoleOptions] = React.useState([]);
    const [searchInAll, setSearchInAll] = React.useState(false);

     useEffect(() => {
       /* getRoleList(organization.id)
            .then(list => {
                setRoleOptions(
                    [
                        ...[{'value': '', label: 'All'}],
                        ...labelizeNamedData(list.data)
                    ]
                )
            })        */
    }, [organization]);

    const rolePlaceholder = role ? role : 'All'
    const onKeywordChange = ( e ) => {
        setKeyword( e.target.value );
    }

    const onRoleChange = ( e ) => {
        setSelectedRoleName(e);
        setUserRole( e.value );
    }

    const onClickFilter = (e) => {
        e.preventDefault();
        onClickFilterCallback({keyword:keyword, role_id: role, search_in_all: searchInAll});
    }

    useEffect(() => {
        setKeyword( filter?.keyword );
        setUserRole( filter?.role_id );
        setSearchInAll( !!filter?.search_in_all );
    }, [filter]);

    const resetFilter  =(e) => {
        setSearchInAll(false);
        onClickFilterCallback({keyword:'', role_id: '', search_in_all: false});
    }

    return (
        <form className="form__form-group" onSubmit={onClickFilter}>
            <Row style={{alignItems: 'center'}} className='filters-wrap'>
                <Col md={3}>
                    <p className="">Search Users</p>
                    <div className="">
                        <Input
                            value={keyword}
                            onChange={onKeywordChange}
                            type="text"
                            name='keywords'
                            placeholder="Search users"
                        />
                    </div>
                </Col>
                <Col md={2}>
                    <p className="">&nbsp;</p>
                    <label className="participants-table__toggle-label">
                        <input
                            type="checkbox"
                            className="participants-table__toggle-check"
                            checked={searchInAll}
                            style={{ width: '14px', height: '14px' }}
                            onChange={() => {
                                const next = !searchInAll;
                                setSearchInAll(next);
                                onClickFilterCallback({ keyword, role_id: role, search_in_all: next });
                            }}
                        />
                        <span title="Selecting this option searches for managers across this program and all of its sub-programs">
                            All Programs
                        </span>
                    </label>
                </Col>
                <Col md={3}>
                    <div className='d-flex align-items-center filter-btns'>
                        <div className="me-4">
                            <p className="">&nbsp;</p>
                            <Button  
                                type='submit'
                                className="btn btn-sm btn-primary mb-0" 
                                color="#ffffff"
                            >
                                Filter
                            </Button>
                        </div>
                        <div >
                            <p className="">&nbsp;</p>
                            <Button  
                                type='reset'
                                className="btn btn-sm btn-secondary mb-0" 
                                color="#ffffff"
                                onClick={resetFilter}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </form>
    )
}

export default FilterForm;